import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconPauseRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.637 29.333 16 29.333M12.333 20a1 1 0 1 0 2 0v-8a1 1 0 0 0-2 0zm5.334 0a1 1 0 0 0 2 0v-8a1 1 0 0 0-2 0z" clipRule="evenodd" /></svg>;
export default SvgIconPauseRoundedFilled;